import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const BookletMaterialCreateSlice = createSlice({
  name: "BookletMaterialCreateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    bookletMaterialCreate: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successBookletMaterialCreate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureBookletMaterialCreate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearBookletMaterialCreate: (state) => {
      state.data = {};
    },
  },
});

export const {
  bookletMaterialCreate,
  failureBookletMaterialCreate,
  successBookletMaterialCreate,
  clearBookletMaterialCreate,
} = BookletMaterialCreateSlice.actions;

export default BookletMaterialCreateSlice.reducer;
